import * as React from "react";
import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";

export type DefaultButtonProps = Omit<
  React.ComponentProps<"button">,
  "children"
> & {
  children?: React.ReactNode;
  variant?: "default" | "green" | "red" | "yellow" | "white";
};

const buttonVariants = cva(
  "group hover:!cursor-pointer disabled:!cursor-not-allowed disabled:grayscale-90 disabled:brightness-100 disabled:saturate-100 bg-transparent px-2.5 py-1 text-white text-xs hover:brightness-95 hover:saturate-95",
  {
    variants: {
      variant: {
        default: "default-btn-container",
        green: "default-btn-green-container",
        red: "default-btn-red-container",
        yellow: "default-btn-yellow-container",
        white: "default-btn-white-container",
      },
    },
  }
);

export function DefaultButton({
  className,
  children,
  variant = "default",
  ...props
}: DefaultButtonProps) {
  return (
    <button
      type="button"
      className={cn(buttonVariants({ variant }), className)}
      {...props}
    >
      {children}
    </button>
  );
}
